import clsx from 'clsx'
import { FC, InputHTMLAttributes, SVGProps } from 'react'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string
  renderLeftIcon?: FC<SVGProps<SVGSVGElement>>
}

export const SimpleInput = ({ containerClassName, renderLeftIcon: LeftIcon, ...restProps }: Props) => {
  return (
    <div className={`relative flex items-center ${containerClassName}`}>
      {LeftIcon && (
        <div className="absolute left-2 flex h-full items-center">
          <LeftIcon className="h-5 text-tertiary" />
        </div>
      )}
      <StyledInput renderLeftIcon={LeftIcon} {...restProps} />
    </div>
  )
}

const StyledInput = ({ renderLeftIcon, className, ...props }: Props) => (
  <input
    {...props}
    className={clsx(
      'h-12 w-full rounded-lg border pr-2 border-secondary focus:outline-none',
      renderLeftIcon ? 'pl-11' : 'pl-2',
      className,
    )}
  />
)
